import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class RegistryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/dev/github/ng4wedding/wedding/src/app/pages/registry/registry.component.ts